import { render, staticRenderFns } from "./ProdutosServicos.vue?vue&type=template&id=073fc5e9&scoped=true"
import script from "./ProdutosServicos.vue?vue&type=script&lang=js"
export * from "./ProdutosServicos.vue?vue&type=script&lang=js"
import style0 from "./ProdutosServicos.vue?vue&type=style&index=0&id=073fc5e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fc5e9",
  null
  
)

export default component.exports